/* template */
<template minapp="mpx" xlang="wxml"><div class="content-explain"><div class="title"><mpx-image :src="(iconSrc)" class="title-icon" v-if="(!explainValue.noIcon)"></mpx-image><div class="title-text">{{ explainValue.title }}</div></div><div class="caption"><div class="caption-icon"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/wrn-rZGc7HA4aqLe5wW8z.png" class="caption-image" v-if="(!explainValue.noIcon)"></mpx-image></div><div class="caption-text"><div v-for="(item, index) in (explainValue.listText)" :key="item.index" class="caption-text-item"><mpx-rich-text :nodes="(item)"></mpx-rich-text></div></div></div><div class="prompt" v-if="(explainValue.prompt)">{{ explainValue.prompt }}</div><div class="tip" v-if="(explainValue.tip)">{{ explainValue.tip }}</div><slot :name="('tabrefund')"></slot><slot :name="('other')"></slot><mpx-image :src="(imgSrc)" class="tab-icon" v-if="(isShowTabIcon)"></mpx-image></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m5641a8c0"}'>
  .content-explain
    position relative
    border-radius 8px
    opacity 1
    display flex
    flex-direction column
    // padding 0px
    box-sizing border-box
    /* 纯白 */
    background #FFFFFF
    .title
      display flex
      height 46px
      align-items center
      margin 0 12px 12px 12px
      border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
      .title-icon
        width 18px
        height 18px
      .title-text
        margin-left 4px
        height 19px
        opacity 1
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 19px
        letter-spacing 0px
        /* 1品牌/01蓝 */
        color #1473FF
    .caption
      margin 0 12px
      display flex
      .caption-image
        width 18px
        height 18px
        margin-right 4px
        flex none
      .caption-text
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 18px
        letter-spacing 0px
        flex 1
        .caption-text-item
          margin-bottom 8px
          &:last-child
            margin-bottom 12px
    .prompt
      margin 0 12px 12px
      box-sizing border-box
      padding 8px 10px
      background #FFF4EE
      color #FF7D41
      border-radius 8px
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 18px
      letter-spacing 0px
    .tip
      font-family PingFangSC-Regular
      font-size 14px
      font-weight normal
      line-height 18px
      letter-spacing 0px
      color #666666
      margin 0 12px 12px 34px
      ::before
        content ''
        display inline-block
        width 4px
        height 4px
        background #999
        border-radius 100%
        vertical-align middle
        margin-right 5px

    .tab-icon
      position absolute
      right 8px
      top 6.6px
      width 48px
      height 50.4px
      opacity 1
      z-index 2
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5641a8c0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./explain.mpx.js?isComponent&outputPath=components%2Fexplain5641a8c0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./explain.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fexplain5641a8c0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5641a8c0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/explain5641a8c0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-rich-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
